<section class="catalog">
  <div class="catalog-actions">
    <div class="catalog-filters">
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="search-field">
        <mat-label>{{ plural }} suchen</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input matInput [(ngModel)]="searchText" autocomplete="off">
      </mat-form-field>

      <mat-button-toggle-group *ngIf="teamMode" [(ngModel)]="originFilter" aria-label="Herkunft filtern"
        class="origin-filter">
        <mat-button-toggle value="all">Alle</mat-button-toggle>
        <mat-button-toggle value="team">Nur dieses Team</mat-button-toggle>
        <mat-button-toggle value="adopted">Aus globalem Katalog</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <div class="catalog-buttons" *ngIf="canEdit">
      <button mat-stroked-button *ngIf="teamMode" [disabled]="saving || loading" (click)="openAdopt()">
        <mat-icon>playlist_add</mat-icon>
        Aus globalem Katalog übernehmen
      </button>
      <button mat-flat-button color="primary" [disabled]="saving || loading" (click)="openCreate()">
        <mat-icon>add</mat-icon>
        {{ singular }} hinzufügen
      </button>
    </div>
  </div>

  <p class="read-only-hint" *ngIf="!canEdit">
    <mat-icon>lock_outline</mat-icon>
    Nur Ansicht – in diesem Bereich darfst du keine {{ plural }} ändern.
  </p>

  <p class="error-message" *ngIf="error" role="alert">
    {{ error }}
    <button mat-button (click)="load()">Erneut versuchen</button>
  </p>

  <div class="loading" *ngIf="loading">
    <mat-spinner diameter="22"></mat-spinner>
    {{ plural }} werden geladen …
  </div>

  <ng-container *ngIf="!loading && !error">
    <p class="item-count">{{ visibleItems.length }} von {{ scopeItems.length }} {{ plural }} · {{ scopeLabel }}</p>

    <div class="management-list" *ngIf="visibleItems.length > 0">
      <div class="management-row" *ngFor="let item of visibleItems; trackBy: trackItem">
        <div class="category-color" [style.backgroundColor]="item.color || '#607d8b'"></div>

        <div class="category-info">
          <strong>{{ item.name }}</strong>
          <div class="item-meta">
            <span class="origin-badge" [ngClass]="origin(item)">{{ originLabel(item) }}</span>
            <span class="category-status absence" *ngIf="!isSkills && item.countsAsAbsence">
              <mat-icon>event_busy</mat-icon> Abwesenheit
            </span>
            <span class="category-status" *ngIf="!isSkills && item.excludeFromCapacity">
              <mat-icon>donut_large</mat-icon> Nicht in Kapazität
            </span>
          </div>
        </div>

        <div class="row-actions">
          <ng-container *ngIf="canEditItem(item)">
            <button mat-icon-button matTooltip="Bearbeiten" [disabled]="saving" (click)="openEdit(item)"
              [attr.aria-label]="item.name + ' bearbeiten'">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button color="warn" matTooltip="Löschen" [disabled]="saving" (click)="remove(item)"
              [attr.aria-label]="item.name + ' löschen'">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </ng-container>
          <button mat-icon-button *ngIf="canEdit && origin(item) === 'adopted'" matTooltip="Aus dem Team entfernen"
            [disabled]="saving" (click)="removeFromTeam(item)" [attr.aria-label]="item.name + ' aus dem Team entfernen'">
            <mat-icon>link_off</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="empty-state" *ngIf="visibleItems.length === 0">
      <mat-icon>{{ scopeItems.length ? 'search_off' : 'inventory_2' }}</mat-icon>
      <p *ngIf="scopeItems.length">Keine {{ plural }} passend zur Suche.</p>
      <ng-container *ngIf="!scopeItems.length">
        <p *ngIf="!teamMode">Es gibt noch keine globalen {{ plural }}.</p>
        <p *ngIf="teamMode">Diesem Team sind noch keine {{ plural }} zugeordnet.</p>
        <p class="empty-hint" *ngIf="teamMode && canEdit">
          Lege einen {{ singular }} nur für dieses Team an oder übernimm Einträge aus dem globalen Katalog.
        </p>
      </ng-container>
    </div>

    <p class="fallback-hint" *ngIf="showGlobalFallbackHint">
      <mat-icon>info_outline</mat-icon>
      Solange diesem Team keine Kategorien zugeordnet sind, stehen in der Teamplanung alle globalen Kategorien zur Verfügung.
    </p>
  </ng-container>

  <!-- Anlegen / Bearbeiten -->
  <div class="edit-overlay" *ngIf="editor" (click)="closeEditor()">
    <div class="edit-dialog" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
      <div class="dialog-header">
        <h3>{{ editor.id === null ? singular + ' hinzufügen' : singular + ' bearbeiten' }}</h3>
        <button mat-icon-button (click)="closeEditor()" [disabled]="saving" aria-label="Schließen">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <p class="scope-note" *ngIf="editor.id === null">
        <mat-icon>{{ teamMode ? 'groups' : 'public' }}</mat-icon>
        Wird angelegt für: <strong>{{ scopeLabel }}</strong>
        <span *ngIf="teamMode"> – andere Teams sehen diesen Eintrag nicht.</span>
      </p>

      <mat-form-field appearance="outline">
        <mat-label>Name</mat-label>
        <input matInput [(ngModel)]="editor.name" maxlength="100" required
          (keydown.enter)="save()">
      </mat-form-field>

      <div class="color-setting">
        <label for="catalogColor">Farbe</label>
        <div class="color-picker-row">
          <input id="catalogColor" type="color" [(ngModel)]="editor.color" [disabled]="saving">
          <span>{{ editor.color }}</span>
          <div class="color-preview" [style.backgroundColor]="editor.color">Vorschau</div>
        </div>
      </div>

      <ng-container *ngIf="!isSkills">
        <mat-checkbox [(ngModel)]="editor.countsAsAbsence" [disabled]="saving">
          Zählt als Abwesenheit
        </mat-checkbox>
        <p class="setting-hint">Termine dieser Kategorie reduzieren die verfügbare Kapazität (z. B. Urlaub).</p>
        <mat-checkbox [(ngModel)]="editor.excludeFromCapacity" [disabled]="saving">
          Nicht in der Kapazität berücksichtigen
        </mat-checkbox>
      </ng-container>

      <div class="dialog-actions">
        <button mat-stroked-button (click)="closeEditor()" [disabled]="saving">Abbrechen</button>
        <button mat-flat-button color="primary" [disabled]="!editor.name.trim() || saving" (click)="save()">
          Speichern
        </button>
      </div>
    </div>
  </div>

  <!-- Aus globalem Katalog übernehmen -->
  <div class="edit-overlay" *ngIf="adoptOpen" (click)="closeAdopt()">
    <div class="edit-dialog adopt-dialog" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
      <div class="dialog-header">
        <h3>Globale {{ plural }} übernehmen</h3>
        <button mat-icon-button (click)="closeAdopt()" [disabled]="saving" aria-label="Schließen">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <p class="scope-note">
        <mat-icon>groups</mat-icon>
        Ausgewählte Einträge werden {{ teamName }} zugeordnet. Der globale Eintrag bleibt unverändert.
      </p>

      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Suchen</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input matInput [(ngModel)]="adoptSearch" autocomplete="off">
      </mat-form-field>

      <div class="adopt-list">
        <mat-checkbox *ngFor="let item of adoptableItems; trackBy: trackItem" [checked]="adoptSelection.has(item.id)"
          (change)="toggleAdopt(item.id, $event.checked)" [disabled]="saving">
          <span class="adopt-item">
            <span class="adopt-color" [style.backgroundColor]="item.color || '#607d8b'"></span>
            {{ item.name }}
          </span>
        </mat-checkbox>
        <p class="empty-state" *ngIf="adoptableItems.length === 0">
          Keine weiteren globalen {{ plural }} verfügbar.
        </p>
      </div>

      <div class="dialog-actions">
        <button mat-stroked-button (click)="closeAdopt()" [disabled]="saving">Abbrechen</button>
        <button mat-flat-button color="primary" [disabled]="adoptSelection.size === 0 || saving" (click)="saveAdopt()">
          {{ adoptSelection.size || '' }} Übernehmen
        </button>
      </div>
    </div>
  </div>
</section>
